import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_ADD_QUIZ_TO_PROFILE,
  ENDPOINT_CREATE_QUIZ_PROFILES,
  ENDPOINT_FINISH_QUIZ,
  ENDPOINT_GET_QUIZ_PROFILES_BY_INTERVIEW,
  ENDPOINT_GET_QUIZ_PROFILES_BY_STEP,
  ENDPOINT_QUIZ_PROFILES,
  ENDPOINT_SAVE_QUIZ_PROFILES_BY_ANSWER,
  ENDPOINT_SEND_EMAIL_QUIZ,
  ENDPOINT_SEND_EMAIL_QUIZ_LOTE,
} from './constants';

export function useQuizProfileService() {
  const { backendGet, backendPost, backendPut } = Sebrae.useBackend();

  const listProfileSteps = React.useCallback(
    (type) => backendGet(`${ENDPOINT_QUIZ_PROFILES}?typeEnum=${type}`),
    [backendGet],
  );

  const listProfileStepsByOrder = React.useCallback(
    ({ idQuiz, order }) =>
      backendGet(
        `${ENDPOINT_GET_QUIZ_PROFILES_BY_STEP}/${idQuiz}?order=${order}`,
      ),
    [backendGet],
  );

  const listProfileStepsByIdInterview = React.useCallback(
    (idInterview) =>
      backendGet(`${ENDPOINT_GET_QUIZ_PROFILES_BY_INTERVIEW}/${idInterview}`),
    [backendGet],
  );

  const sendEmail = React.useCallback(
    (idInterview) => backendGet(`${ENDPOINT_SEND_EMAIL_QUIZ}/${idInterview}`),
    [backendGet],
  );

  const finishQuizService = React.useCallback(
    (idQuiz) => backendPost(`${ENDPOINT_FINISH_QUIZ}/${idQuiz}`),
    [backendPost],
  );

  const createQuizProfile = React.useCallback(
    (params) => backendPost(`${ENDPOINT_CREATE_QUIZ_PROFILES}`, params),
    [backendPost],
  );

  const addAnswersToQuizProfile = React.useCallback(
    (idQuiz, params) =>
      backendPost(`${ENDPOINT_ADD_QUIZ_TO_PROFILE}/${idQuiz}`, params),
    [backendPost],
  );

  const updateQuizProfileQuestion = React.useCallback(
    (id, params) =>
      backendPut(`${ENDPOINT_SAVE_QUIZ_PROFILES_BY_ANSWER}/${id}`, params),
    [backendPut],
  );

  const sendQuizLote = React.useCallback(
    (ids) => backendGet(`${ENDPOINT_SEND_EMAIL_QUIZ_LOTE}?${ids}`),
    [backendGet],
  );

  return {
    listProfileSteps,
    createQuizProfile,
    listProfileStepsByOrder,
    updateQuizProfileQuestion,
    listProfileStepsByIdInterview,
    addAnswersToQuizProfile,
    finishQuizService,
    sendEmail,
    sendQuizLote,
  };
}
